import { getRoles } from "../api/providers";

export const checkRole = async (token: any, roleToCheck: string): Promise<boolean> => {
    try {
        const result = await getRoles(token);
        if (!result.ok) {
            // Maneja el error como consideres necesario
            return false;
        }

        const data = result.roles;

        // Asumiendo que data es un array de roles, verifica si el rol está presente
        return data.includes(roleToCheck);
    } catch (error: any) {
        console.log(error.response.data);
        // En caso de error, devuelve false o maneja el error como consideres necesario
        return false;
    }
};